import React, { useEffect, useState } from "react";
import {
  Tabs,
  Modal,
  Button,
  Switch,
  Input,
  Checkbox,
  Radio,
  Tag,
  message,
  Select,
} from "antd";
import {
  BellOutlined,
  CalendarOutlined,
  ClockCircleOutlined,
} from "@ant-design/icons";
import {
  ColorLensOutlined,
  RepeatOnOutlined,
  RepeatOn,
} from "@mui/icons-material";
import "../../App.css";
import eventicon from "../../Assets/calender/Event-icon.png";
import taskicon from "../../Assets/calender/Task-icon.png";
import TimeSelect from "../CalenderModal/TimeSelect";
import Reminder from "../CalenderModal/Reminder";
import { URL } from "../../helper/Mainurl";
import FloatLabel from "../FloatLabel";
import ChecklistComponent from "../ChecklistComponent";
import DetailsList from "../DetailsList";
import "../CalenderModal/FilterModal.css";
import "./AddCoParentTask.css";
import DateModalTask from "../CalenderModal/DateModalTask";
import moment from "moment";
import AssignToModal from "./AssignCoParentToModal";
import CollaborationModal from "./CollaborationCoParentModal";
import RepeatModal from "./RepeatModalCoParent";
import ColorsModal from "./ColorsModalCoParent";
import { Color } from "antd/es/color-picker";
const AddTask = ({
  isModalOpen,
  closeModal,
  couples,
  allChildren,
  onTaskUpdate,
  defaultDate,
}) => {
  // console.log("couples",couples)
  const token = localStorage.getItem("authToken"); // Get token from localStorage

  const [activeTab, setActiveTab] = useState("1");
  // const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const [timeModalOpen, setTimeModalOpen] = useState(false);
  const [isReminderOpen, setIsReminderOpen] = useState(false);
  const [radioMeta, setRadioMeta] = useState([]);
  const [displayName, setDisplayName] = useState([]);
  const [priority, setPriority] = useState([]);
  const [selectedDisplayId, setSelectedDisplayId] = useState(null);
  const [selectedPriorityIds, setSelectedPriorityIds] = useState(null);
  const [inputText, setInputText] = useState("");
  const [inputTextDesc, setInputTextDesc] = useState(null);
  const [locationText, setLocationText] = useState(null);
  const [selectedDisplayName, setSelectedDisplayName] = useState(null);
  const [selectedChilds, setSelectedChilds] = useState(null);
  const [selectedCoupleId, setSelectedCoupleId] = useState(null);
  const [selectedChildIds, setSelectedChildIds] = useState(null);
  const [assignName, setAssignName] = useState("No Assignees");
  const [submutLoading, setSubmitLoading] = useState(false);
  const [error, setError] = useState(false);

  const [selectedRadioId, setSelectedRadioId] = useState(null);

  const [checklist, setChecklist] = useState([
    { title: "", description: null, is_checked: 1 },
  ]);
  const [newChecklistText, setNewChecklistText] = useState("");
  const [editingItemId, setEditingItemId] = useState(null);
  const [value, setValue] = useState(1);
  const [selectedTime, setSelectedTime] = useState({ start: "", end: "" });
  const [selectedReminder, setSelectedReminder] = useState("No reminder");
  const [switchStates, setSwitchStates] = useState(false);
  const [switchTimeStates, setSwitchTimeStates] = useState(false);
  const [switchStatesRem, setSwitchStatesRem] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  useEffect(() => {
    if (defaultDate) {
      setSelectedDate(defaultDate);
      setSwitchStates(true);
    } else if (defaultDate === null) {
      setSelectedDate(null);
      setSwitchStates(false);
    }
  }, [defaultDate]);
  const [showTimeModal, setShowTimeModal] = useState(false);
  const [showRemModal, setShowRemModal] = useState(false);
  const [selectReminder, setSelectReminder] = useState(false);
  const [descSelectedReminder, setDescSelectedReminder] =
    useState("No reminder");
  const [descSelectedColor, setDescSelectedColor] = useState("No Color");
  const [showAssignModal, setShowAssignModal] = useState(false);
  const [assignedUsers, setAssignedUsers] = useState([]);
  const [showCollaborationModal, setShowCollaborationModal] = useState(false);
  const [switchStatesCollaboration, setSwitchStatesCollaboration] =
    useState(false);
  const [selectedCollaborators, setSelectedCollaborators] = useState([]);

  const [dummyCollaborators, setDummyCollaborators] = useState([
    {
      id: "1",
      name: "Thomas Shelby",
      email: "thomas@gmail.com",
      permission: "Can View",
      avatar: "https://i.pravatar.cc/40?img=1",
    },
    {
      id: "2",
      name: "Emily Clarke",
      email: "emily@gmail.com",
      permission: "Can Edit",
      avatar: "https://i.pravatar.cc/40?img=2",
    },
    {
      id: "3",
      name: "John Doe",
      email: "john@gmail.com",
      permission: "Can View",
      avatar: "https://i.pravatar.cc/40?img=3",
    },
  ]);
  const [showRepeatModal, setShowRepeatModal] = useState(false);
  const [showColorModal, setShowColorModal] = useState(false);

  // State for switch toggle
  const [switchStatesRepeat, setSwitchStatesRepeat] = useState(false);
  const [switchStatesColor, setSwitchStatesColor] = useState(false);
  const [switchStatesNotification, setSwitchStatesNotification] =
    useState(false);
  const [colorConfig, setColorConfig] = useState(null);

  const [metaData, setMetaData] = useState([]);

  // Repeat settings configuration
  const [repeatConfig, setRepeatConfig] = useState(null);
  const [repeatOption, setRepeatOption] = useState([]);
  // Toggle repeat switch
  const handleSwitchChangeRepeat = () => {
    const newState = !switchStatesRepeat;
    setSwitchStatesRepeat(newState);

    if (newState) {
      // Show modal when turning on
      setShowRepeatModal(true);
    } else {
      // Clear config when turning off
      setRepeatConfig(null);
    }
  };
  const handleSwitchChangeColor = () => {
    const newState = !switchStatesRepeat;
    setSwitchStatesColor(newState);

    if (newState) {
      // Show modal when turning on
      setSwitchStatesColor(true);
    } else {
      // Clear config when turning off
      setColorConfig(null);
    }
  };
  const handleSwitchChangeNotification = () => {
    const newState = !switchStatesNotification;
    setSwitchStatesNotification(newState);
  };

  const getRepeatDescription = () => {
    if (!switchStatesRepeat || !repeatConfig) return "No repeat";

    const { repeatType, endType, occurrences, customEndDate } = repeatConfig;
    if (!repeatType?.label_name) return "No repeat";

    const endText =
      endType === "custom"
        ? `until ${moment(customEndDate).format("D MMMM YYYY")}`
        : `after ${occurrences} ${occurrences === 1 ? "year" : "years"}`;

    return `${repeatType.label_name} (Ends ${endText})`;
  };

  // Handle saving from RepeatModal
  const handleRepeatSave = (data) => {
    setRepeatConfig(data);
    setSwitchStatesRepeat(true);
    setShowRepeatModal(false);
  };
  const handleColorSave = (data) => {
    // console.log("colorConfig",colorConfig)
    // setRepeatConfig(data);
    setColorConfig(data);
    if (!data.id) {
      setSwitchStatesColor(false);
    } else {
      setSwitchStatesColor(true);
    }
    setShowColorModal(false);
    setDescSelectedColor(data.label_name);
  };
  useEffect(() => {
    // console.log('setRepeatConfig', repeatConfig);
    // You can perform side effects here, such as API calls or other logic
  }, [repeatConfig]);
  // Cancel modal
  const handleRepeatCancel = () => {
    // If no config and switch is off, don't keep modal open
    if (!repeatConfig) {
      setSwitchStatesRepeat(false);
    }
    setShowRepeatModal(false);
  };
  const handleColorCancel = () => {
    // If no config and switch is off, don't keep modal open
    // if (!colorConfig.id) {
    //   setSwitchStatesColor(false);
    // }
    setShowColorModal(false);
  };

  const handleSwitchChangeCollaboration = (checked) => {
    setSwitchStatesCollaboration(checked);
  };

  const handleSaveCollaboration = (selected) => {
    setSelectedCollaborators(selected);
    setSwitchStatesCollaboration(selected.length > 0);
    setShowCollaborationModal(false);

    // Add any new collaborators not already in dummyCollaborators
    const newCollaborators = selected.filter(
      (sel) => !dummyCollaborators.some((c) => c.id === sel.id)
    );
    if (newCollaborators.length > 0) {
      setDummyCollaborators((prev) => [...prev, ...newCollaborators]);
    }
    // console.log("dummyCollaborators", selectedCollaborators)
  };
  useEffect(() => {
    if (selectedCollaborators.length > 0) {
      // console.log('Collaborators updated:', selectedCollaborators);
      // You can perform side effects here, such as API calls or other logic
    }
  }, [selectedCollaborators]);

  const descSelectedCollaboration =
    selectedCollaborators.length > 0
      ? selectedCollaborators.map((c) => c.name).join(", ")
      : "No collaborators selected";

  const userList = [
    {
      id: "1",
      name: "John Doe",
      email: "john.doe@example.com",
      avatar: "https://randomuser.me/api/portraits/men/1.jpg",
    },
    {
      id: "2",
      name: "Jane Smith",
      email: "jane.smith@example.com",
      avatar: "https://randomuser.me/api/portraits/women/2.jpg",
    },
    {
      id: "3",
      name: "Alice Johnson",
      email: "alice.johnson@example.com",
      avatar: "https://randomuser.me/api/portraits/women/3.jpg",
    },
    {
      id: "4",
      name: "Bob Brown",
      email: "bob.brown@example.com",
      avatar: "https://randomuser.me/api/portraits/men/4.jpg",
    },
  ];
  const parentCouple = couples.find((couple) => couple.id === selectedCoupleId);
  const parentUsers = parentCouple
    ? [
      {
        id: parentCouple.parent1.user_id,
        name: parentCouple.parent1.nickname || parentCouple.parent1.name,
        email: parentCouple.parent1.email,
        avatar: "",
      },
      {
        id: parentCouple.parent2.user_id,
        name: parentCouple.parent2.nickname || parentCouple.parent2.name,
        email: parentCouple.parent2.email,
        avatar: "",
      },
    ]
    : [];

  const allAssignUsers = [...userList, ...parentUsers];

  // Now build selectedNames from allAssignUsers
  useEffect(() => {
    const selectedNames =
      allAssignUsers
        .filter((u) => assignedUsers.includes(u.id))
        .map((u) => u.name || u.email)
        .join(", ") || "No Assignees";
    setAssignName(selectedNames);
  }, []);
  // const selectedNames = userList
  //   .filter((u) => assignedUsers.includes(u.id))
  //   .map((u) => u.name)
  //   .join(", ") || "No Assign";

  const handleDateSelect = (date) => {
    setSelectedDate(date);
    setShowModal(false); // Close modal after selecting a date
    setSwitchStates(!!date); // Correctly update state
    console.log("Selected Date:", date);
  };

  const handleSwitchChange = () => {
    setShowModal(true);
  };
  const handleSwitchChangeTime = () => {
    setShowTimeModal(true);
  };
  const handleSwitchChangeaAssign = () => { };
  const handleSwitchChangeRem = () => {
    const newState = !switchStatesRem;
    setSwitchStatesRem(newState);
    if (!newState) {
      // If the switch was ON and now turned OFF, show the modal
      // setShowRemModal(true);
      setSwitchStatesRem(false);
      setDescSelectedReminder("");
    } else {
      // If the switch was OFF and now turned ON
      setSelectedReminder(null);
      setSwitchStatesRem(true); // Ensure the switch turns ON
      setShowRemModal(true);
    }
  };

  const handleSelectDisplay = (id) => {
    setSelectedDisplayId(id); // Store only one selected ID
  };

  // Handle selecting a Priority
  const handleSelectPriority = (id) => {
    setSelectedPriorityIds(id);
  };

  const getCalenderMetaData = async () => {
    try {
      const response = await fetch(`${URL}/v1/calendar/get-calendar-metadata`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();
      if (data.code == 200) {
        setMetaData(data.data);
        setRadioMeta(data.data.progress_status);
        setDisplayName(data.data.display_name);
        setRepeatOption(data.data.repeat_option);
        setPriority(data.data.priority);
      } else {
        console.error("Invalid response from server:", data); // Log detailed error
        // message.error("Failed to load profile data."); // User-friendly error message
      }
      // console.log("response>>>>>", data);
    } catch (error) { }
  };

  useEffect(() => {
    getCalenderMetaData();
  }, []);

  const onChange = (key) => {
    console.log(key);
  };

  const handleSelectDate = (date) => {
    setSelectedDate(date);
  };

  const formatDateTimeRem = (selectedDate, selectedTime, selectedReminder) => {
    // Validate selected date
    if (!selectedDate || !selectedTime?.start) {
      return { taskStartTime: null, reminderText: "No reminder" };
    }

    const formattedStartDate = moment(selectedDate, "D MMMM YYYY").format(
      "YYYY-MM-DD"
    );

    let formattedDate = moment(
      formattedStartDate,
      ["YYYY-MM-DD", "YYYY/MM/DD", "MM-DD-YYYY", "MM/DD/YYYY"],
      true
    );
    if (!formattedDate.isValid()) {
      formattedDate = moment(
        selectedDate,
        ["YYYY-MM-DD", "YYYY/MM/DD", "MM-DD-YYYY", "MM/DD/YYYY"],
        true
      );
    }

    let formattedStartTime = moment(
      selectedTime?.start,
      ["HH:mm", "HH:mm:ss"],
      true
    );
    if (!formattedStartTime.isValid()) {
      return { taskStartTime: null, reminderText: "No reminder" };
    }

    const taskStartTime = moment
      .utc(
        `${formattedDate.format("YYYY-MM-DD")} ${formattedStartTime.format(
          "HH:mm"
        )}`
      )
      .utc()
      .format("YYYY-MM-DDTHH:mm:ss[Z]");

    // If no reminder is selected, return "No reminder"
    if (!selectedReminder) {
      return { taskStartTime, reminderText: "No reminder" };
    }

    const reminderTime = moment.utc(selectedReminder); // Convert reminder to UTC
    const eventStartTime = moment.utc(taskStartTime); // Convert event start to UTC

    // Validate reminder time
    if (!reminderTime.isValid() || reminderTime.isAfter(eventStartTime)) {
      return { taskStartTime, reminderText: "No reminder" };
    }

    const diffMinutes = eventStartTime.diff(reminderTime, "minutes") || 0;
    const diffHours = eventStartTime.diff(reminderTime, "hours") || 0;
    const diffDays = eventStartTime.diff(reminderTime, "days") || 0;

    let reminderText = "No reminder"; // Default value

    if (diffDays === 0 && diffHours === 0 && diffMinutes > 0) {
      reminderText = `${diffMinutes} minutes before`;
    } else if (diffDays === 0 && diffHours > 0) {
      reminderText = `${diffHours} hours, ${diffMinutes % 60} minutes before`;
    } else if (diffDays > 0) {
      reminderText = `${diffDays} days, ${diffHours % 24} hours, ${diffMinutes % 60
        } minutes before`;
    }

    return { taskStartTime, reminderText };
  };

  const handleSelectTime = (timeData) => {
    setSelectedTime(timeData);

    setSwitchTimeStates(!!timeData);
    // Example output: { startTime: "08:00", endTime: "09:00" }
    const { taskStartTime, reminderText } = formatDateTimeRem(
      selectedDate,
      selectedTime,
      selectedReminder
    );

    setDescSelectedReminder(reminderText);
  };
  useEffect(() => {
    // console.log("Updated switch state:", switchStatesRem);
  }, [switchStatesRem]);
  const handleSelectReminder = (reminder, checked) => {
    const { taskStartTime, reminderText } = formatDateTimeRem(
      selectedDate,
      selectedTime,
      reminder
    );
    console.log("reminderText", reminderText);
    setSelectedReminder(reminder);
    setDescSelectedReminder(reminderText);
    setSwitchStatesRem(!!reminder);

    // console.log("SelectedReminder>>", reminder, "Task Start Time>>", taskStartTime);
  };
  const selectTextReminder = (item) => {
    console.log("nananan", item);
    setDescSelectedReminder(item);
  };
  const getTabName = (key) => (key == "1" ? "task" : "event");

  const tabName = getTabName(activeTab); // Convert tab number to "task" or "event"

  const handleCoupleChange = (value) => {
    console.log("Selected couple ID:", value);
    setSelectedCoupleId(value);
    setSelectedChildIds(null);
    // Fetch children based on selected couple ID
    const selectedCouple = couples.find((couple) => couple.id === value);
    if (selectedCouple) {
      const children = selectedCouple.children.map((child) => ({
        id: child.id,
        name: child.name,
      }));
      console.log("Selected couple's children:", selectedCouple.children);
      setSelectedChilds(selectedCouple.children);
    }
  };
  const handleChildSelect = (value) => {
    console.log("Selected child ID:", value);
    setSelectedChildIds(value);
  };

  const handleSubmitNew = async () => {
    setSubmitLoading(true);
    // console.log(selectedTime, "Selected Time");

    if (!inputText.trim() || !inputText) {
      setError(true);
      message.error(`${tabName} title is required!`);
      setSubmitLoading(false);
      return;
    }
    if (selectedDate === null || selectedDate === undefined) {
      message.error("Please select a date.");
      setSubmitLoading(false);
      return;
    }
    const getRepetitionEndDate = () => {
      if (!repeatConfig || !formattedStartDate) return null;

      const { endType, occurrences, customEndDate } = repeatConfig;

      if (endType === "custom" && customEndDate) {
        return moment(customEndDate).format("YYYY-MM-DD");
      }

      return moment(formattedStartDate)
        .add(occurrences, "years")
        .format("YYYY-MM-DD");
    };

    const hasSaturday = repeatConfig?.excludeWeekends?.some(
      (w) => w.label === "saturday"
    );
    const hasSunday = repeatConfig?.excludeWeekends?.some(
      (w) => w.label === "sunday"
    );
    let adjustWeekendsValue = null;

    if (repeatConfig?.adjustWeekends) {
      if (hasSaturday && hasSunday) {
        adjustWeekendsValue = "previous_friday";
      } else if (hasSaturday) {
        adjustWeekendsValue = "previous_friday";
      } else if (hasSunday) {
        adjustWeekendsValue = "previous_saturday";
      }
    }
    const formattedStartDate = moment(selectedDate, "D MMMM YYYY").format(
      "YYYY-MM-DD"
    );
    // Ensure start time, end time, and reminder timestamp are in ISO 8601 UTC format
    let formattedDate = moment(formattedStartDate);
    if (!formattedDate.isValid()) {
      formattedDate = moment(
        selectedDate,
        ["YYYY-MM-DD", "YYYY/MM/DD", "MM-DD-YYYY", "MM/DD/YYYY"],
        true
      );
    }

    let taskStartTime = null;
    let taskEndTime = null;

    if (selectedTime?.start) {
      const formattedStartTime = moment(
        selectedTime.start,
        ["HH:mm", "HH:mm:ss"],
        true
      );
      taskStartTime = moment
        .utc(
          `${formattedDate.format("YYYY-MM-DD")} ${formattedStartTime.format(
            "HH:mm"
          )}`,
          "YYYY-MM-DD HH:mm"
        )
        .format("YYYY-MM-DDTHH:mm:ss[Z]");
    }

    if (selectedTime?.end) {
      const formattedEndTime = moment(
        selectedTime.end,
        ["HH:mm", "HH:mm:ss"],
        true
      );
      taskEndTime = moment
        .utc(
          `${formattedDate.format("YYYY-MM-DD")} ${formattedEndTime.format(
            "HH:mm"
          )}`,
          "YYYY-MM-DD HH:mm"
        )
        .format("YYYY-MM-DDTHH:mm:ss[Z]");
    }

    if (!taskStartTime || !taskEndTime) {
      message.error("Please select both start and end times.");
      setSubmitLoading(false);
      return;
    }

    const formatedAssign =
      assignedUsers
        ?.filter(
          (user) => user.parent_id !== null && user.parent_id !== undefined
        )
        .map((user) => user.parent_id) || [];

    const formatedEmails =
      assignedUsers
        ?.filter(
          (user) =>
            (user.parent_id === null || user.parent_id === undefined) &&
            user.coparent_email
        )
        .map((user) => user.coparent_email) || [];

    const formattedReminder = moment(
      selectedReminder,
      "YYYY-MM-DD HH:mm"
    ).format("YYYY-MM-DDTHH:mm:ss[Z]");
    // const checkedItems = checklist.filter(item => item.checked).map(item => item.text);
    const checkListItems = checklist.map((item) => ({
      title: item.title,
      // description: '', // You can customize the description here
      is_checked: item.is_checked,
    }));
    const selectedChildIdsNumber = Array.isArray(selectedChildIds)
      ? selectedChildIds.map(Number)
      : [];
    const taskPayload = {
      coparent_combination_id: selectedCoupleId,
      child_ids: selectedChildIdsNumber,
      title: inputText,
      location: locationText,
      description: inputTextDesc,
      display_name_id: selectedDisplayId,
      priority_id: selectedPriorityIds,
      progress_status_id: selectedRadioId,
      start_date: formattedStartDate,
      start_time: taskStartTime,
      end_time: taskEndTime,
      reminder_timestamp: switchStatesRem ? formattedReminder : null, // If task-related, include checklist
      repeat_option: repeatConfig ? repeatConfig.repeatType.value : null, // Include repeat option if set
      repetition_end_date: getRepetitionEndDate(), // Include custom end date if set
      exclude_saturdays: repeatConfig?.excludeWeekends?.some(
        (w) => w.label === "saturday"
      )
        ? 1
        : 0,
      exclude_sundays: repeatConfig?.excludeWeekends?.some(
        (w) => w.label === "sunday"
      )
        ? 1
        : 0,
      adjust_weekends: adjustWeekendsValue,
      assignee_ids: formatedAssign, // Use parent_id for assignee
      assignee_emails: formatedEmails, // Use coparent_email for assignee emails
      color_id: colorConfig?.id,
      is_notification_enabled: switchStatesNotification ? 1 : 0,
    };
    console.log("taskPayload", taskPayload);
    console.log("repeatConfig", repeatConfig);
    // Payload for Event (with additional fields like event description)
    const eventPayload = {
      coparent_combination_id: selectedCoupleId,
      child_ids: selectedChildIdsNumber,
      title: inputText,
      location: locationText,
      description: inputTextDesc,
      display_name_id: selectedDisplayId,
      priority_id: selectedPriorityIds,
      progress_status_id: selectedRadioId,
      start_date: formattedStartDate,
      start_time: taskStartTime,
      end_time: taskEndTime,
      participant_ids: formatedAssign, // Use parent_id for assignee
      participant_emails: formatedEmails, // Use coparent_email for assignee emails
      reminder_timestamp: switchStatesRem ? formattedReminder : null, // If task-related, include checklist
      repeat_option: repeatConfig ? repeatConfig.repeatType.value : null, // Include repeat option if set
      repetition_end_date: getRepetitionEndDate(),
      // exclude_saturdays: repeatConfig?.excludeWeekends?.length ?  Number(!repeatConfig.excludeWeekends.includes("saturday")) : 0,
      // exclude_sundays: repeatConfig?.excludeWeekends?.length ?  Number(!repeatConfig.excludeWeekends.includes("sunday")) : 0,
      exclude_saturdays: repeatConfig?.excludeWeekends?.some(
        (w) => w.label === "saturday"
      )
        ? 1
        : 0,
      exclude_sundays: repeatConfig?.excludeWeekends?.some(
        (w) => w.label === "sunday"
      )
        ? 1
        : 0,
      adjust_weekends: adjustWeekendsValue,
      check_list: checkListItems, // If event-related, include checklist
      color_id: colorConfig?.id,
      is_notification_enabled: switchStatesNotification ? 1 : 0,
    };

    const payload = tabName === "task" ? taskPayload : eventPayload;

    console.log("Final Payload:", payload);

    try {
      const response = await fetch(`${URL}/v1/co-parenting/create-${tabName}`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "Cache-Control": "no-cache",
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();
      if (data.code === 200) {
        message.success(`${tabName} Created Successfully`);
        resetFormFields();
        setSubmitLoading(false);
        closeModal();
        if (onTaskUpdate) {
          onTaskUpdate();
        }
        // Clear form fields and state after successful submission

        setError(false);
      } else {
        const errorMessage =
          data.message || data.error || `Failed to create ${tabName}`;
        message.error(errorMessage);
        setSubmitLoading(false);
      }
    } catch (error) {
      console.error("Error:", error);
      setSubmitLoading(false);
    }
  };

  useEffect(() => {
    // Reset form fields when the active tab changes
    resetFormFields();
  }, [activeTab]); //
  const resetFormFields = () => {
    setInputText("");
    setInputTextDesc(null);
    setLocationText(null);
    if (!isModalOpen) {
      setSelectedDate(null);
    }
    setSelectedTime({ start: "", end: "" });
    setSelectedReminder("No reminder");
    setDescSelectedReminder("No reminder");
    setDescSelectedColor("No Color");
    setSelectedDisplayId(null);
    setSelectedPriorityIds(null);
    setSelectedRadioId(null);
    if (!isModalOpen) {
      setSwitchStates(null);
    }
    setSwitchTimeStates(false);
    setSwitchStatesRem(false);
    setChecklist([]); // Reset checklist
  };

  const handleChange = (e) => {
    setInputText(e.target.value);
    setError(false); // Clear error when user types

    // Update state on input change
  };

  const handleChangeDesc = (e) => {
    setInputTextDesc(e.target.value); // Update state on input change
  };
  const handleChangeLocation = (e) => {
    setLocationText(e.target.value); // Update state on input change
  };

  const handleRadioChange = (e) => {
    const slectedStatusID = e.target.value;
    setSelectedRadioId(slectedStatusID);
  };

  const options = [
    { label: "Pending", value: "pending" },
    { label: "Success", value: "success" },
  ];
  const eventContent = (
    <div>
      <div className="addTaskLabel">
        <FloatLabel
          label="What is the name of your Event"
          name="taskTitle"
          value={inputText}
          required
        >
          <Input value={inputText} onChange={handleChange} placeholder="" />
        </FloatLabel>
        {/* {error && <Text type="danger">{tabName} Name is required!</Text>} */}
      </div>

      <FloatLabel
        label="Description"
        name="taskDescription"
        value={inputTextDesc}
      >
        <Input.TextArea
          placeholder=""
          value={inputTextDesc}
          onChange={handleChangeDesc}
          autoSize={{ minRows: 1, maxRows: 6 }}
        />
      </FloatLabel>

      <FloatLabel label="Location" name="taskLocation" value={locationText}>
        <Input
          placeholder=""
          value={locationText}
          onChange={handleChangeLocation}
        />
      </FloatLabel>
      <FloatLabel label="Select a couple" value={selectedCoupleId} required>
        <Select
          placeholder=""
          width="100%"
          style={{ display: "flex" }}
          onChange={handleCoupleChange}
        >
          {couples.map((item) => (
            <Select.Option key={item.id} value={item.id}>
              {item.parent1.name && item.parent1.name.trim() !== ""
                ? item.parent1.name
                : item.parent1.nickname && item.parent1.nickname.trim() !== ""
                  ? item.parent1.nickname
                  : item.parent1.email}
              -
              {item.parent2.name && item.parent2.name.trim() !== ""
                ? item.parent2.name
                : item.parent2.nickname && item.parent2.nickname.trim() !== ""
                  ? item.parent2.nickname
                  : item.parent2.email}
            </Select.Option>
          ))}
        </Select>
      </FloatLabel>
      {selectedChilds && selectedChilds.length > 0 && (
        <FloatLabel label="Select childs" value={selectedChildIds} required>
          <Select
            mode="multiple"
            value={selectedChildIds}
            placeholder="Select childs"
            width="100%"
            style={{ display: "flex", marginTop: "20px" }}
            onChange={handleChildSelect}
          >
            {selectedChilds.map((item) => (
              <Select.Option key={item.id} value={item.id}>
                {item.name}
              </Select.Option>
            ))}
          </Select>
        </FloatLabel>
      )}

      <div>
        <ChecklistComponent checklist={checklist} setChecklist={setChecklist} />
      </div>
      {/* Status */}
      <div className="radio-container">
        <h3>
          Status <span style={{ color: "red" }}>*</span>
        </h3>
        <Radio.Group
          className="custom-radio-group"
          onChange={handleRadioChange}
        >
          {radioMeta.length > 0 ? (
            radioMeta.map((status) => (
              <Radio key={status.id} value={status.id} className="custom-radio">
                {status.label_name}
              </Radio>
            ))
          ) : (
            <p>Loading...</p> // Optional loading state
          )}
        </Radio.Group>
      </div>
      <div className="display-container">
        <h3>
          Preferred Display Name <span style={{ color: "red" }}>*</span>
        </h3>
        <div className="">
          {displayName.map((status) => (
            <Tag
              onClick={() => handleSelectDisplay(status.id)}
              style={{
                backgroundColor:
                  selectedDisplayId === status.id ? "#FEF1FE" : "#ffffff",
                color: selectedDisplayId === status.id ? "#9A4FE0" : "#000",
                border:
                  selectedDisplayId === status.id
                    ? "1px solid #9A4FE0"
                    : "1px solid #E1E6EF",
                borderRadius: "10px",
                cursor: "pointer",
                fontSize: "14px",
                padding: "8px 12px",
                lineHeight: "18px",
              }}
              key={status.id}
            >
              {status.label_name}
            </Tag>
          ))}
        </div>
      </div>
      {/* Priority */}
      <div className="priority-container">
        <h3>
          Priority <span style={{ color: "red" }}>*</span>
        </h3>
        <div className="">
          {priority.length > 0 ? (
            priority.map((status) => (
              <Tag
                onClick={() => handleSelectPriority(status.id)}
                style={{
                  backgroundColor:
                    selectedPriorityIds === status.id ? "#FEF1FE" : "#ffffff",
                  color: selectedPriorityIds === status.id ? "#9A4FE0" : "#000",
                  border:
                    selectedPriorityIds === status.id
                      ? "1px solid #9A4FE0"
                      : "1px solid #E1E6EF",
                  borderRadius: "10px",
                  cursor: "pointer",
                  fontSize: "14px",
                  padding: "8px 12px",
                  lineHeight: "18px",
                }}
                key={status.id}
              >
                {status.label_name}
              </Tag>
            ))
          ) : (
            <p>Loading...</p> // Optional loading state
          )}
        </div>
      </div>

      {/* Details Section */}
      {/* <div className='details-container'>
        <h3 className='details-title'>Detail</h3>
        <DetailsList
        icon={<BellOutlined />}
        title="Collaboration"
        description={descSelectedCollaboration}
        switchChecked={switchStatesCollaboration}
        onSwitchChange={handleSwitchChangeCollaboration}
        onClick={() => setShowCollaborationModal(true)}
      />
        <DetailsList
        icon={<CalendarOutlined />}
        title="Date"
        description={selectedDate || "No date selected"}
        switchChecked={switchStates}
        onSwitchChange={() => handleSwitchChange()}
        onClick={() => setShowModal(true)} // Open modal on click
      />

      <DetailsList
        icon={<ClockCircleOutlined />}
        title="Time"
        description={selectedTime.start && selectedTime.end ? `${selectedTime.start} - ${selectedTime.end}` : "Add time"}
        switchChecked={switchTimeStates}
        onSwitchChange={() => handleSwitchChangeTime()}
        onClick={() => setShowTimeModal(true)} 
        
      />

      <DetailsList
        icon={<BellOutlined />}
        title="Reminder"
        description={
          descSelectedReminder === "No reminder"
            ? "No Reminder"
            : descSelectedReminder
        }
        switchChecked={switchStatesRem}
        onSwitchChange={() => handleSwitchChangeRem()}
        onClick={() => setShowRemModal(true)} 
       
      />
     <DetailsList
        icon={<BellOutlined />}
        title="Repeat"
        description={getRepeatDescription()}
        switchChecked={switchStatesRepeat}
        onSwitchChange={handleSwitchChangeRepeat}
        onClick={() => setShowRepeatModal(true)}
      />
      <DetailsList
        icon={<BellOutlined />}
        title="Color"
        description={
          descSelectedReminder === "No reminder"
            ? "No Reminder"
            : descSelectedReminder
        }
        switchChecked={switchStatesRem}
        onSwitchChange={() => handleSwitchChangeaAssign()}
        onClick={() => setShowRemModal(true)} 
       
      />
      </div> */}

      {/* Footer */}
      {/* <div style={{ display: "flex", justifyContent: "space-between", marginTop: "20px" }}>
        <Button onClick={closeModal} className="modal-cancel-btn">Cancel</Button>
        <Button type='primary' className="modal-success-btn" onClick={handleSubmitNew}>Save</Button>
      </div> */}
    </div>
  );
  const taskContent = (
    <div>
      <div className="addTaskLabel">
        <FloatLabel
          label="What is the name of your task"
          name="taskTitle"
          value={inputText}
          required
        >
          <Input value={inputText} onChange={handleChange} placeholder="" />
        </FloatLabel>
        {/* {error && <Text type="danger">{tabName} Name is required!</Text>} */}
      </div>

      <FloatLabel
        label="Description"
        name="taskDescription"
        value={inputTextDesc}
      >
        <Input.TextArea
          value={inputTextDesc}
          onChange={handleChangeDesc}
          autoSize={{ minRows: 1, maxRows: 6 }}
        />
      </FloatLabel>

      <FloatLabel label="Location" name="taskLocation" value={locationText}>
        <Input
          value={locationText}
          onChange={handleChangeLocation}
          placeholder=""
        />
      </FloatLabel>
      <FloatLabel label="Select a couple" value={selectedCoupleId} required>
        <Select
          placeholder=""
          width="100%"
          style={{ display: "flex" }}
          onChange={handleCoupleChange}
        >
          {couples.map((item) => (
            <Select.Option key={item.id} value={item.id}>
              {item.parent1.name && item.parent1.name.trim() !== ""
                ? item.parent1.name
                : item.parent1.nickname && item.parent1.nickname.trim() !== ""
                  ? item.parent1.nickname
                  : item.parent1.email}
              -
              {item.parent2.name && item.parent2.name.trim() !== ""
                ? item.parent2.name
                : item.parent2.nickname && item.parent2.nickname.trim() !== ""
                  ? item.parent2.nickname
                  : item.parent2.email}
            </Select.Option>
          ))}
        </Select>
      </FloatLabel>
      {selectedChilds && selectedChilds.length > 0 && (
        <FloatLabel label="Select childs" value={selectedChildIds} required>
          <Select
            mode="multiple"
            value={selectedChildIds}
            placeholder=""
            width="100%"
            style={{ display: "flex", marginBottom: "10px", marginTop: "20px" }}
            onChange={handleChildSelect}
          >
            {selectedChilds.map((item) => (
              <Select.Option key={item.id} value={item.id}>
                {item.name}
              </Select.Option>
            ))}
          </Select>
        </FloatLabel>
      )}

      {/* <div>
      <ChecklistComponent checklist={checklist} setChecklist={setChecklist} />
    </div> */}
      {/* Status */}
      <div className="radio-container">
        <h3>
          Status <span style={{ color: "red" }}>*</span>
        </h3>
        <Radio.Group
          className="custom-radio-group"
          onChange={handleRadioChange}
        >
          {radioMeta.length > 0 ? (
            radioMeta.map((status) => (
              <Radio key={status.id} value={status.id} className="custom-radio">
                {status.label_name}
              </Radio>
            ))
          ) : (
            <p>Loading...</p> // Optional loading state
          )}
        </Radio.Group>
      </div>
      <div className="display-container">
        <h3>
          Preferred Display Name <span style={{ color: "red" }}>*</span>
        </h3>
        {displayName.map((status) => (
          <Tag
            onClick={() => handleSelectDisplay(status.id)}
            style={{
              backgroundColor:
                selectedDisplayId === status.id ? "#FEF1FE" : "#ffffff",
              color: selectedDisplayId === status.id ? "#9A4FE0" : "#000",
              border:
                selectedDisplayId === status.id
                  ? "1px solid #9A4FE0"
                  : "1px solid #E1E6EF",
              borderRadius: "10px",

              cursor: "pointer",
              fontSize: "14px",
              padding: "8px 12px",
              lineHeight: "18px",
            }}
            key={status.id}
          >
            {status.label_name}
          </Tag>
        ))}
      </div>
      {/* Priority */}
      <div className="priority-container">
        <h3>
          Priority <span style={{ color: "red" }}>*</span>
        </h3>
        {priority.length > 0 ? (
          priority.map((status) => (
            <Tag
              onClick={() => handleSelectPriority(status.id)}
              style={{
                backgroundColor:
                  selectedPriorityIds === status.id ? "#FEF1FE" : "#ffffff",
                color: selectedPriorityIds === status.id ? "#9A4FE0" : "#000",
                border:
                  selectedPriorityIds === status.id
                    ? "1px solid #9A4FE0"
                    : "1px solid #E1E6EF",
                borderRadius: "10px",
                cursor: "pointer",
                fontSize: "14px",
                padding: "8px 12px",
                lineHeight: "18px",
              }}
              key={status.id}
            >
              {status.label_name}
            </Tag>
          ))
        ) : (
          <p>Loading...</p> // Optional loading state
        )}
      </div>

      {/* Details Section */}

      {/* Footer */}
      {/* <div style={{ display: "flex", justifyContent: "space-between", marginTop: "20px" }}>
        <Button onClick={closeModal} className="modal-cancel-btn">Cancel</Button>
        <Button type='primary' className="modal-success-btn" onClick={handleSubmitNew}>Save</Button>
      </div> */}
    </div>
  );

  // console.log("switchStatesRepeat", switchStatesRepeat)
  return (
    <>
      <Modal
        title={`Add ${tabName === "task" ? "Task" : "Event"}`}
        open={isModalOpen}
        onCancel={closeModal}
        footer={false}
        maskClosable={false}
      >
        <div>
          <div>
            <span style={{ fontSize: "16px", fontWeight: "600" }}>
              Category
            </span>
            <Tabs
              defaultActiveKey="1"
              activeKey={activeTab}
              onChange={setActiveTab}
              className="custom-tabs"
            >
              <Tabs.TabPane
                tab={
                  <span>
                    <img src={taskicon} width={12} /> Task
                  </span>
                }
                key="1"
              >
                {taskContent}
              </Tabs.TabPane>
              <Tabs.TabPane
                tab={
                  <span>
                    <img src={eventicon} width={12} /> Events
                  </span>
                }
                key="2"
              >
                {eventContent}
              </Tabs.TabPane>
            </Tabs>
            <div className="details-container">
              <h3 className="details-title">Detail</h3>
              <DetailsList
                icon={<BellOutlined />}
                title="Assign To"
                description={assignName}
                switchChecked={assignedUsers.length > 0}
                onSwitchChange={() => setShowAssignModal(true)}
                onClick={() => setShowAssignModal(true)}
              />
              {/* <DetailsList
        icon={<BellOutlined />}
        title="Collaboration"
        description={descSelectedCollaboration}
        switchChecked={switchStatesCollaboration}
        onSwitchChange={handleSwitchChangeCollaboration}
        onClick={() => setShowCollaborationModal(true)}
      /> */}
              <DetailsList
                icon={<CalendarOutlined />}
                title="Date"
                description={selectedDate || "No date selected"}
                switchChecked={switchStates}
                onSwitchChange={() => handleSwitchChange()}
                onClick={() => setShowModal(true)} // Open modal on click
                required
              />

              <DetailsList
                icon={<ClockCircleOutlined />}
                title="Time"
                description={
                  selectedTime.start && selectedTime.end
                    ? `${selectedTime.start} - ${selectedTime.end}`
                    : "Add time"
                }
                switchChecked={switchTimeStates}
                onSwitchChange={() => handleSwitchChangeTime()}
                onClick={() => setShowTimeModal(true)}
                required
              />

              <DetailsList
                icon={<BellOutlined />}
                title="Reminder"
                description={
                  descSelectedReminder === "No reminder"
                    ? "No Reminder"
                    : descSelectedReminder
                }
                switchChecked={switchStatesRem}
                onSwitchChange={handleSwitchChangeRem}
                onClick={() => setShowRemModal(true)}
              />
              <DetailsList
                icon={<RepeatOnOutlined />}
                title="Repeat"
                description={getRepeatDescription()}
                switchChecked={switchStatesRepeat}
                onSwitchChange={handleSwitchChangeRepeat}
                onClick={() => setShowRepeatModal(true)}
              />
              <DetailsList
                icon={<ColorLensOutlined />}
                title="Color"
                description={descSelectedColor}
                switchChecked={switchStatesColor}
                onSwitchChange={() => handleSwitchChangeColor()}
                onClick={() => setShowColorModal(true)}
              />
              <DetailsList
                icon={<BellOutlined />}
                title="Notification"
                // description={descSelectedColor}
                switchChecked={switchStatesNotification}
                onSwitchChange={() => handleSwitchChangeNotification()}
                onClick={() => handleSwitchChangeNotification()}
              />
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "20px",
                gap: '5px'
              }}
            >
              <Button onClick={closeModal} className="modal-cancel-btn">
                Cancel
              </Button>
              <Button
                type="primary"
                className="modal-success-btn"
                loading={submutLoading}
                disabled={submutLoading}
                onClick={handleSubmitNew}
              >
                Save
              </Button>
            </div>
          </div>
        </div>
      </Modal>
      <div>
        {/* <DateCalender isOpen={isCalendarOpen} onClose={() => setIsCalendarOpen(false)} onSelectDate={handleSelectDate} /> */}
        <DateModalTask
          show={showModal}
          handleClose={() => setShowModal(false)}
          onDateSelect={handleDateSelect}
          selectedDate={selectedDate}
        />
      </div>

      <div>
        <TimeSelect
          show={showTimeModal}
          handleClose={() => setShowTimeModal(false)}
          onSelectTime={handleSelectTime}
          selectedDate={selectedDate}
        />
      </div>
      <div>
        <Reminder
          show={showRemModal}
          handleClose={() => setShowRemModal(false)}
          onSelectReminder={handleSelectReminder}
          eventDate={selectedDate}
          eventTime={selectedTime}
          selectReminderTime={selectTextReminder}
        />
        <AssignToModal
          visible={showAssignModal}
          onCancel={() => setShowAssignModal(false)}
          onSave={(newSelection) => {
            const selectedNames = newSelection
              .map(
                (user) =>
                  user.name || user.coparent_nickname || user.coparent_email
              )
              .join(", ");
            setAssignName(selectedNames);
            setAssignedUsers(newSelection);
            setShowAssignModal(false);
          }}
          selectedUsers={assignedUsers}
          selectedCoupleId={selectedCoupleId}
          couples={couples}
          users={userList}
        />
        <CollaborationModal
          visible={showCollaborationModal}
          onCancel={() => setShowCollaborationModal(false)}
          onSave={handleSaveCollaboration}
          collaborators={dummyCollaborators}
          selectedUsers={assignedUsers}
          selectedCoupleId={selectedCoupleId}
          couples={couples}
          initialSelected={selectedCollaborators}
        />
        <RepeatModal
          visible={showRepeatModal}
          onClose={handleRepeatCancel}
          onSave={handleRepeatSave}
          initialValues={repeatConfig}
          repeatOption={repeatOption}
          onCancel={handleRepeatCancel}
        />
        <ColorsModal
          metaData={metaData.colors}
          visible={showColorModal}
          onCancel={handleColorCancel}
          onSave={handleColorSave}
          initialValues={colorConfig}
        />
      </div>
    </>
  );
};

export default AddTask;
